/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react'

const JIRA = props => {

    const removeAllJiraElements = () => {
        //get rid of all current jira tags so new ones can be created with current data
        const ids = ['jiraTag', 'atlwdg-trigger', 'atlwdg-blanket' ,'atlwdg-container'];
        ids.forEach(id => {
            const elem = document.getElementById(id);
            if(elem != null){
                elem.parentNode.removeChild(elem);
            }        
        })
    }

    const setNewJiraFields = () => {
        let interactionType = props.contentData.modules[props.currentLocation.module].lessons[props.currentLocation.lesson].chapters[props.currentLocation.chapter].segments[props.currentLocation.segment].type;
        const moduleIdentifier = `module-${props.currentLocation.module}`
        const lessonIdentifier = `lesson-${props.currentLocation.lesson}`
        const chapterIdentifier = `chapter-${props.currentLocation.chapter}`
        const segmentIdentifier = `segment-${props.currentLocation.segment}`
        const deeplink = `${props.generateLocationLink()}`

        //this is setting up fields for jira
        window.ATL_JQ_PAGE_PROPS = {
            environment : function(){
                var env_info = {};    
                return env_info;
            }, 
            fieldValues:{
                // app location, user location, sco label custom fields
                summary: `int= ${interactionType} `,
                'customfield_10026': `${moduleIdentifier} ${lessonIdentifier} ${chapterIdentifier} ${segmentIdentifier}`,
                'customfield_10100': `${deeplink}`,
                'customfield_10200': `${moduleIdentifier}`
            }                  
        }
    }

    const createJiraTag = () => {
        //create new jira tag based on props.jiraTag
        const scriptTag = document.createElement('script');
        scriptTag.id = 'jiraTag';
        scriptTag.type = 'text/javascript';
        scriptTag.async = true;
        scriptTag.src = props.jiraTag;
        document.body.appendChild(scriptTag);
        // console.log(scriptTag)
    }

    useEffect(()=>{
        //every time current location or jira tag changes, refresh jira
        if(props.jiraTag && props.currentLocation){
            removeAllJiraElements();
            setNewJiraFields();
            createJiraTag();
        }
    }, [props.jiraTag, props.currentLocation])


    return (
        //we don't need to render anything, handled by jira script tag from atlassian
        <></>
    )
}

export default JIRA